import { FixaTextArea } from "@coworker/apprestructured/src/shared/wrappers/FixaTextArea/FixaTextArea";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import InputWrapper from "@coworker/apprestructured/src/task-management/components/InputWrapper/InputWrapper";
import { useTranslation } from "@coworker/locales";
import styles from "./TitledTextArea.module.css";

type TitledTextAreaProps = {
  className?: string;
  title?: string;
  header?: React.ReactNode;
  subtitle?: string;
  label: string;
  ariaLabel?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
  disabled?: boolean;
  rows?: number;
};

function TitledTextArea({
  className,
  title,
  header,
  subtitle,
  label,
  ariaLabel,
  value,
  onChange,
  error,
  disabled,
  rows = 3,
}: TitledTextAreaProps) {
  const { t } = useTranslation();

  return (
    <div className={styles["root"] + (className ? ` ${className}` : "")}>
      {header
        ? header
        : title && (
            <FixaText textStyle="Heading.S" tagName="h2">
              {t(title)}
            </FixaText>
          )}
      <InputWrapper error={error}>
        <FixaTextArea
          label={t(label)}
          aria-label={ariaLabel ? t(ariaLabel) : undefined}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          rows={rows}
          disabled={disabled}
        />
      </InputWrapper>
      {subtitle && <FixaText textStyle="Body.S">{t(subtitle)}</FixaText>}
    </div>
  );
}

export default TitledTextArea;
